import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/timeRoundingPolicy`;

export const ROUTE: RouteDefinition = `${baseRoute}/timeRoundingPolicy`;

export const URL = (): RouteDefinition => `${baseRoute}/timeRoundingPolicy`;
